import React, { Component } from "react";
import { Switch } from "react-router";
import AuthorizeRoute from "../components/api-authorization/AuthorizeRoute";
import { OverviewPage } from "../pages/admin-page/OverviewPage";
import { ReportsPage } from "../pages/admin-page/ReportsPage";
import { SettingsPage } from "../pages/admin-page/SettingsPage";
import { AccountManagementPage } from "../pages/admin-page/account-management-page/AccountManagementPage";
import { AdminLayout } from "./AdminLayout";
import { Layout } from "./Layout";
import { RouteWithLayout } from "./RouteWithLayout";
import { UserNotFoundInEvf } from "../pages/UserNotFoundInEvf";

export class AdminSwitch extends Component {
  render() {
    return (
      <Switch>
        <AuthorizeRoute layout={AdminLayout} exact path="/" component={OverviewPage} />
        <RouteWithLayout layout={Layout} path="/user-not-found-in-evf" component={UserNotFoundInEvf} shouldIgnoreAntiforgeryToken={true} />
        <AuthorizeRoute layout={AdminLayout} exact path="/overview" component={OverviewPage} />
        <AuthorizeRoute layout={AdminLayout} exact path="/reports" component={ReportsPage} />
        <AuthorizeRoute layout={AdminLayout} exact path="/settings" component={SettingsPage} />
        <AuthorizeRoute layout={AdminLayout} exact path="/account-management" component={AccountManagementPage} />
      </Switch>
    );
  }
}
